export const md5 = '9ffc8d05';
    export const md5Legacy = '15a2b6e8';
    export const md5Dark = 'c81bb818';
    export const md5DarkLegacy = '3284d440';
    